// import io from 'socket.io-client'
import { Message } from 'element-ui'
const state = {
    socket: null,
    chatGptMsg: {},
    completeTokens: {},
}
const getters = {
    socket: state => state.socket,
    chatGptMsg: state => state.chatGptMsg,
    completeTokens: state => state.completeTokens,
}
const mutations = {
    startSocket(state) {
        var token = this.getters.userInfo.newToken;
        // eslint-disable-next-line no-undef
        state.socket = io.connect(u_config.socketApi + '?params=' + token + '', { transports: ['websocket', 'xhr-polling', 'jsonp-polling'] });
        state.socket.on('chatGptMsg', (res) => {
            this.commit("setAiLoading", false)
            state.chatGptMsg = res;
        });
        state.socket.on('completeExceedTokens', (res) => {
            state.chatGptMsg = { end: true };
            this.commit("setAiLoading", false)
            Message({
                message: res,
                type: 'error',
                duration: 5000
            })
        });
        state.socket.on('chatGptMsgComplete', (res) => {
            state.chatGptMsg = { end: true, size: res };
        });
        state.socket.on('completeTokens', (res) => {
            state.completeTokens = { size: res };
        });
        state.socket.on('openAIError', () => {
            state.chatGptMsg = { end: true };
            this.commit("setAiLoading", false)
            Message({
                message: "OPENAI出错了，重新生成试试",
                type: 'error',
                duration: 5000
            })
        });
    },
    sendMessage(state, obj) {
        if (!state.socket) return;
        state.socket.emit(obj.key, obj);
        if (obj.key == "disconnectChatGpt") {
            state.socket.close();
            setTimeout(() => {
                state.socket.open();
            }, 500)
        }
    },
}

const actions = {

}


export default {
    state,
    getters,
    actions,
    mutations
}